import { motion } from "framer-motion";
import { Link } from "gatsby";
import React, { useRef, useState } from "react";
import { MdKeyboardArrowRight } from "react-icons/md";
import useIntersectionObserver from "./useIntersectionObserver";

export default function ShareYourStoryButton({ show }) {
  return (
    <>
      <motion.div
        initial={{ opacity: 0, pointerEvents: "none" }}
        animate={
          show
            ? { opacity: 1, pointerEvents: "auto" }
            : { opacity: 0, pointerEvents: "none" }
        }
        className="fixed bottom-0 w-full text-center z-40   mb-3  "
      >
        {" "}
        <Link
          to="/doty-voting-2024"
          className="bg-accent text-button font-bench leading-none inline-flex items-center justify-center  py-2  text-white rounded-full relative "
          style={{
            width:"260px",
            height:"50px",
            
          }}>
          CAST YOUR VOTE TO WIN{" "}
          <MdKeyboardArrowRight className="absolute right-0 mr-8v2" />
        </Link>
      </motion.div>
    </>
  );
}
